__turbopack_context__.v({
  "bundleItemLink": "eeFNOa_bundleItemLink",
  "bundleTitle": "eeFNOa_bundleTitle",
  "content": "eeFNOa_content",
  "header": "eeFNOa_header",
  "is-selected": "eeFNOa_is-selected",
  "megabundle-pick-button": "eeFNOa_megabundle-pick-button",
  "pick-button": "eeFNOa_pick-button",
  "plusNote": "eeFNOa_plusNote",
  "price": "eeFNOa_price",
  "price-text": "eeFNOa_price-text",
  "pricing": "eeFNOa_pricing",
  "pricing-overview": "eeFNOa_pricing-overview",
  "pricing-toggle": "eeFNOa_pricing-toggle",
  "pricing-toggle-wrapper": "eeFNOa_pricing-toggle-wrapper",
  "pricingCard": "eeFNOa_pricingCard",
  "pricingCardCta": "eeFNOa_pricingCardCta",
  "pricingCardLabel": "eeFNOa_pricingCardLabel",
  "pricingCardSavings": "eeFNOa_pricingCardSavings",
  "pricingPlans": "eeFNOa_pricingPlans",
  "single-price": "eeFNOa_single-price",
});
